import Vue from 'vue'
import Vuex from 'vuex'
import i18n from '@/common/i18n/i18n'
import vueRouter from '@/router'
import { getRemainingTime } from '@/utils/utils'
import { getEventDetailApi, reserveResultApi, cancelResultApi, getCountryCodeListApi } from '@/api/melco'
import { getPersonalNoticesApi } from '@/api/member'
import { getConfigApi, getActivityLabelGroupApi, getEventLabelGroupApi } from '@/api/utsv'
import moment from 'moment'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    fontSize: '16px',
    themeColor: 'default',
    subscribeUrl: '/Member/Subscribe.do?redirectUrl=' + encodeURIComponent(window.location.href),
    isLogin: localStorage.getItem('isLogin') === 'true',
    userInfo: {},
    personalNotices: null,
    remainingTimer: null,
    remainingStr: localStorage.getItem('remainingStr') ? JSON.parse(localStorage.getItem('remainingStr')) : '',
    remainingStartMill: localStorage.getItem('remainingStartMill') ? JSON.parse(localStorage.getItem('remainingStartMill')) : null,
    logoutModal: {
      visible: false,
      title: '',
      content: ''
    },
    allMill: localStorage.getItem('allMill') ? JSON.parse(localStorage.getItem('allMill')) : 1000 * 60 * 15,
    firstShowLogoutModal: false,
    globalLoading: false,
    langLabelCode: {},
    currencySymbol: 'HK$',
    handLoading: false,
    // melco数据
    eventInfo: {},
    eventConfig: {},
    eventDates: [],
    // 用于存储用户选则的ticket type数据
    selectTicketType: sessionStorage.getItem('selectTicketType') ? JSON.parse(sessionStorage.getItem('selectTicketType')) : {},
    reserveInfo: (() => {
      try {
        const RESERVE_INFO_KEY = 'reserveInfo'
        const _storage = localStorage.getItem(RESERVE_INFO_KEY)
        if (!_storage) {
          return null
        }
        const _jsonStorage = JSON.parse(_storage)
        if (process.env.NODE_ENV === 'development') {
          return _jsonStorage.data
        }
        if (_jsonStorage.exp > Date.now()) {
          return _jsonStorage.data
        } else {
          localStorage.removeItem(RESERVE_INFO_KEY)
          return null
        }
      } catch (err) {
        return null
      }
    })(),
    isPaymentError: false,
    countryCodeList: []
  },
  getters: {
    getMelcoI18nLabel () {
      return (obj, key) => {
        let suffixField = 'Tc'
        if (i18n.locale === 'en_US') {
          suffixField = 'En'
        } else if (i18n.locale === 'zh_CN') {
          suffixField = 'Sc'
        }
        return obj[key + suffixField] || obj[key + 'Tc']
      }
    },
    getLabelCode ({ langLabelCode }) {
      return (labelName) => {
        const lang = i18n.locale === 'zh_HK' ? 'zh_TW' : i18n.locale
        return langLabelCode[lang]?.[labelName]
      }
    }
  },
  mutations: {
    setFontSize (state, size) {
      state.fontSize = size
    },
    setColor (state, color) {
      state.themeColor = color
    },
    setLocationHref (state) {
      state.subscribeUrl = '/Member/Subscribe.do?redirectUrl=' + encodeURIComponent(window.location.href)
    },
    setIsLogin (state, obj) {
      state.isLogin = obj.isLogin
      if (obj.isLogin && obj.clTK) {
        localStorage.setItem('CL_TK', obj.clTK)
      }
    },
    setUserInfo (state, userInfo) {
      state.userInfo = userInfo
    },
    setPersonalNotices (state, list) {
      state.personalNotices = list
    },
    setRemainingStartMill (state, mill) {
      state.remainingStartMill = mill
    },
    initRemainingStartMill (state) {
      clearInterval(state.remainingTimer)
      state.remainingStartMill = null
    },
    setRemainingStr (state, str) {
      state.remainingStr = str
    },
    setFirstShowLogoutModal (state, bool) {
      state.firstShowLogoutModal = bool
    },
    setLogoutModal (state, { visible, title, content }) {
      if (visible !== undefined) {
        state.logoutModal.visible = visible
      }
      if (title !== undefined) {
        state.logoutModal.title = title
      }
      if (content !== undefined) {
        state.logoutModal.content = content
      }
    },
    setRemainingTimer (state, timer) {
      if (state.remainingTimer) {
        clearInterval(state.remainingTimer)
      }
      state.remainingTimer = timer
    },
    clearRemainingTimer (state) {
      clearInterval(state.remainingTimer)
    },
    setGlobalLoading (state, bool) {
      state.globalLoading = bool
    },
    setAllMill (state, mill) {
      state.allMill = mill
      localStorage.setItem('allMill', mill)
    },
    setLangLabelCode (state, langLabelCode) {
      state.langLabelCode = langLabelCode
    },
    setCurrencySymbol (state, currencySymbol) {
      state.currencySymbol = currencySymbol
    },
    setHandLoading (state, bool) {
      state.handLoading = bool
    },
    setEventInfo (state, eventInfo) {
      state.eventInfo = eventInfo
    },
    setEventConfig (state, eventConfig) {
      state.eventConfig = eventConfig
    },
    setEventDates (state, eventDates) {
      state.eventDates = eventDates
    },
    resetMelcoInfo (state) {
      state.eventInfo = {}
      state.eventConfig = {}
      state.eventDates = []
    },
    setReserveInfo (state, reserveInfo, refreshTime = true) {
      state.reserveInfo = reserveInfo
      // 15分钟有效时间
      if (!reserveInfo) {
        localStorage.removeItem('reserveInfo')
      } else if (refreshTime) {
        localStorage.setItem('reserveInfo', JSON.stringify({
          exp: Date.now() + 1000 * 60 * 15,
          data: reserveInfo
        }))
      }
    },
    setIsPaymentError (state, bool) {
      state.isPaymentError = bool
    },
    setCountryCodeList (state, list) {
      const specificDialCodes = ['852', '853', '86', '886']
      const specificItems = list.filter(item => specificDialCodes.includes(item.dial_code))
      specificItems.sort((a, b) => {
        const indexA = specificDialCodes.indexOf(a.dial_code)
        const indexB = specificDialCodes.indexOf(b.dial_code)
        return indexA - indexB
      })
      const remainingItems = list.filter(item => !specificDialCodes.includes(item.dial_code))
      remainingItems.sort((a, b) => a.dial_code - b.dial_code)
      const sortedCountryDialCodesList = specificItems.concat(remainingItems)
      const resArr = []
      sortedCountryDialCodesList.forEach(item => {
        if (!resArr.find(resItem => resItem.dial_code === item.dial_code)) {
          resArr.push(item)
        }
      })
      state.countryCodeList = resArr
    },
    setSelectTicketType (state, selectTicketType = {}) {
      state.selectTicketType = selectTicketType
    }
  },
  actions: {
    async getCountryCodeList ({ commit }) {
      const countryCodeList = await getCountryCodeListApi()
      console.log('country code:', countryCodeList)
      commit('setCountryCodeList', countryCodeList)
    },
    async getPersonalNotices (context) {
      try {
        const res = await getPersonalNoticesApi()
        if (res && res.data && Array.isArray(res.data)) {
          context.commit('setPersonalNotices', res.data)
        } else {
          console.log('get personal notices else:', res)
        }
      } catch (error) {
        console.log('get personal notices error:', error)
      }
    },
    logoutModalCancel ({ state, commit }) {
      commit('cancelReserve')
      commit('setLogoutModal', {
        visible: false
      })
      if (!state.remainingStartMill) {
        window.location.href = Vue.prototype.$cwLink + '?lang=' + i18n.locale
      }
    },
    countNumberInterval ({ state, commit, dispatch }) {
      if (state.remainingStartMill) {
        const remainingTimer = setInterval(() => {
          try {
            /* 获取倒计时,Str是UI回显，mill是值 */
            const remainingObj = getRemainingTime(state.allMill, state.remainingStartMill)
            commit('setRemainingStr', remainingObj.remainingStr)
            /* 当小于一半时间向上取整分钟时弹窗提示 */
            const minutes = Math.ceil(state.allMill / 2 / 60 / 1000)
            if (remainingObj.remainingMill < (minutes * 60 * 1000) && !state.firstShowLogoutModal) {
              commit('setFirstShowLogoutModal', true)
              commit('setLogoutModal', {
                visible: true,
                title: '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0',
                content: i18n.t('remaining-time-warning', { time: minutes })
              })
            }
          } catch (err) {
            commit('clearRemainingTimer')
            /* 初始化倒计时 */
            commit('setRemainingStr', i18n.tc('time-finished'))
            dispatch('cancelReserve')
            commit('setLogoutModal', {
              visible: true,
              title: i18n.tc('app-logout-title'),
              content: i18n.tc('INT0042')
            })
          }
        }, 1000)
        commit('setRemainingTimer', remainingTimer)
      }
    },
    async initConfig ({ commit }) {
      const currentRoute = vueRouter.currentRoute
      const activityCode = currentRoute.params.activityCode
      const eventId = currentRoute.query.event
      if (activityCode !== 'internet') {
        // 初始化 货币符号
        const config = await getConfigApi()
        commit('setCurrencySymbol', config.currencySymbol)
        // 初始化 labelGroup
        const activitySessionKey = `LG_CACHE_${activityCode}`
        const eventSessionKey = `${activitySessionKey}_${eventId}`
        const activitySessionValue = sessionStorage.getItem(activitySessionKey)
        const eventSessionValue = sessionStorage.getItem(eventSessionKey)
        const allTask = []
        allTask.push(activitySessionValue ? Promise.resolve(JSON.parse(activitySessionValue)) : getActivityLabelGroupApi())
        allTask.push(eventSessionValue ? Promise.resolve(JSON.parse(eventSessionValue)) : eventId ? getEventLabelGroupApi(eventId) : Promise.resolve({}))
        const [activityLabelGroup, eventLabelGroup] = await Promise.all(allTask)
        if (!activitySessionValue) {
          sessionStorage.setItem(activitySessionKey, JSON.stringify(activityLabelGroup))
        }
        if (!eventSessionValue) {
          sessionStorage.setItem(eventSessionKey, JSON.stringify(eventLabelGroup))
        }
        const labelGroup = Object.assign(activityLabelGroup.labelGroupJsonList, eventLabelGroup.labelGroupJsonList)
        const map = {
          zh_CN: {},
          zh_TW: {},
          en_US: {}
        }
        labelGroup.forEach(item => {
          if (item.caption === '(null)') {
            map[item.langCode][item.displayCode] = ''
          } else {
            map[item.langCode][item.displayCode] = item.caption
          }
        })
        commit('setLangLabelCode', map)
      }
    },
    async initMelcoEvent ({ commit }, eventId) {
      const eventRes = await getEventDetailApi(eventId)
      const lang = i18n.locale === 'zh_HK' ? 'zh_TW' : i18n.locale
      const eventInfo = eventRes.body[lang]
      console.log('eventInfo:', eventInfo)
      document.title = eventInfo.name
      commit('setEventInfo', eventInfo)
      commit('setEventConfig', eventRes.config)
      const dates = []
      eventInfo.sessions.forEach(item => {
        dates.push(...item.sessions)
      })
      const filterNoCategoryList = dates.filter(item => {
        const startTime = item.starts_timestamp * 1000
        if (
          moment().isBefore(moment(eventRes.config.onSaleTime)) ||
          (eventRes.config.onSaleEnd && moment().isAfter(moment(eventRes.config.onSaleEnd)))
        ) {
          console.log('the current time is more than on sale end', item)
          return false
        }
        const dayBefore = moment(startTime).subtract(eventRes.config.stopSalesBeforeDays, 'days')
        const isValidTime = dayBefore.isAfter(moment())
        if (item.category_qty_data && item.category_qty_data.length >= 0 && isValidTime) {
          return true
        } else {
          console.log('missing category_qty_data', item)
        }
      })
      commit('setEventDates', filterNoCategoryList)
    },
    // 提交订单
    async reserveResult ({ commit }, { eventId, requestBody }) {
      const reserveRes = await reserveResultApi(eventId, requestBody)
      reserveRes.body = JSON.parse(reserveRes.body)
      console.log('remaining_time: ', reserveRes.body.remaining_time)
      // arr[0] 是分， arr[1]是秒
      const arr = reserveRes.body.remaining_time.split(':')
      // 1. recon countdown 5 minutes: 5 * 60 * 1000
      // 2. assign at least 40 seconds to open recon & complete melco order: 40 * 1000
      // 3. ui countdown after reserve: reserve remaining_time - #1 - #2
      commit('setAllMill', Number(arr[0]) * 60 * 1000 + Number(arr[1] * 1000) - 5 * 60 * 1000 - 40 * 1000)
      commit('setReserveInfo', reserveRes)
    },
    async cancelReserve ({ commit, state }, loading = true) {
      commit('initRemainingStartMill')
      if (state.reserveInfo && state.eventInfo && state.eventInfo.id) {
        await cancelResultApi(state.eventInfo.id, {
          reference: state.reserveInfo.reference,
          order_id: state.reserveInfo.order_id
        }, loading)
      }
      commit('setReserveInfo', null)
    },
    async resetReserve ({ commit }) {
      commit('initRemainingStartMill')
      commit('setReserveInfo', null)
    }
  },
  modules: {
  }
})
